<div class="hero">
  <div class="hero-overlay"></div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h1>
          <span class="fw-light">Welcome to Identibase</span><br />
        </h1>
      </div>
    </div>
  </div>
</div>

<div class="container mt-4">
  <div class="row mb-3">
    <div class="col-12">
      <p></p>
      <h4>We are sorry, this pet is marked as passed away in our database</h4>
      <p></p>
    </div>
  </div>
</div>
